import { Input, Slider } from "@mui/material";
import { Question } from "./models/Questions";
import { useState } from 'react'
import './Questionnaire.css'
import PageTitle from "./PageTitle";

export default function RangeQuestion(props: any) {

    let currentQuestion: Question = props.question;

    const [value, setValue] = useState<Number | Number[]>(30);

    const handleSliderChange = (event: Event, newValue: number | number[]) => {
        setValue(newValue);
        currentQuestion.answers[0].val = Number(newValue);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value === '' ? 0 : Number(event.target.value));
        currentQuestion.answers[0].val = Number(event.target.value);
    };

    const handleBlur = () => {
        if (value < 0) {
            setValue(0);
        } else if (value > 100) {
            setValue(100);
        }
    };

    return (
        <div className="questionnaire__container">
            <div className="questionnaire__questions">
                <div className="questionnaire__questions-header">
                    <PageTitle />
                    <hr className="questionnaire__title-separator"></hr>
                    <div className="title questionnaire__question-title">
                        <span>{currentQuestion.text}</span>
                    </div>
                </div>
            </div>
            <div className="questionnaire__question">
                <div className="answers">
                    <Input
                        className="slide-input"
                        value={value}
                        size="medium"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        inputProps={{
                            step: 10,
                            min: 0,
                            max: 100,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                        }}
                    />
                    <Slider
                        value={typeof value === 'number' ? value : 0}
                        onChange={handleSliderChange}
                        aria-labelledby="input-slider"
                    />

                </div>
            </div>
        </div>
    )

}
